import { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from 'context/AuthContext';
import { safeJSONParse } from 'utils/helpers/safeParsing';
import type { ProductContextValue, ProductProviderProps } from '../types';

const ProductContext = createContext<ProductContextValue | null>(null);

export const useProduct = (): ProductContextValue => useContext(ProductContext) as ProductContextValue;

export const ProductProvider = ({ children }: ProductProviderProps) => {
    const { auth } = useAuth();
    const orderName = `voltox-${auth.user.ID}-product-order`;
    const descName = `voltox-${auth.user.ID}-product-desc`;

    const [showEditProduct, setShowEditProduct] = useState<number | false>(false);
    const [showPriceProduct, setShowPriceProduct] = useState<number | false>(false);
    const [showSpinner, setShowSpinner] = useState(false);
    const [listResetNonce, setListResetNonce] = useState(0);
    const [listRefreshNonce, setListRefreshNonce] = useState(0);
    const [productsOrder, setProductsOrder] = useState<string | false>(
        safeJSONParse(sessionStorage.getItem(orderName)) || '',
    );
    const [productsDesc, setProductsDesc] = useState(
        safeJSONParse(sessionStorage.getItem(descName)) === true,
    );
    const [productCheck, setProductCheck] = useState<number[]>([]);

    useEffect(() => {
        sessionStorage.setItem(orderName, JSON.stringify(productsOrder));
    }, [productsOrder, orderName]);

    useEffect(() => {
        sessionStorage.setItem(descName, JSON.stringify(productsDesc));
    }, [productsDesc, descName]);

    const triggerListReset = () => setListResetNonce((nonce) => nonce + 1);
    const triggerListRefresh = () => setListRefreshNonce((nonce) => nonce + 1);

    const values: ProductContextValue = {
        showEditProduct,
        setShowEditProduct,
        showPriceProduct,
        setShowPriceProduct,
        showSpinner,
        setShowSpinner,
        productsOrder,
        setProductsOrder,
        productsDesc,
        setProductsDesc,
        productCheck,
        setProductCheck,
        listResetNonce,
        triggerListReset,
        listRefreshNonce,
        triggerListRefresh,
    };

    return <ProductContext.Provider value={values}>{children}</ProductContext.Provider>;
};
